import React from 'react'
import Grid from '@material-ui/core/Grid'
import { ExperienceTableWrapper, ExperienceStatusBadge } from 'components'

const data = [
  {
    id: 4,
    label: `Experiencia en proceso de edición por parte del Proveedor, al crear, al editar una experiencia.`,
  },
  {
    id: 3,
    label: `Experiencia enviada a validar por parte del Proveedor, con la intención de ser publicada. En este estado es responsabilidad del validador revisar si el contenido cumple con los requisitos para ser Aprobada o por el contrario, Rechazada. Para ello, se deberá cumplir con los plazos de revisión definidos por el Administrador.`,
  },
  {
    id: 5,
    label: `Experiencia Aprobada que podría ser pausada por el propio Proveedor cuando considere que ésta no debe estar publicada ni visible por los turistas. `,
  },
  {
    id: 7,
    label: `Experiencia Aprobada y que a solicitud del Validador regional requiere actualizar parte de su información (tarifas, período de operación, tono y estilo de la redacción, etc.). `,
  },
  {
    id: 8,
    label: `Experiencia Aprobada y que a solicitud del Proveedor requiere actualizar parte de la información (tarifas, periodo de operación, etc.). `,
  },
  {
    id: 1,
    label: `Experiencia validada y publicada por el Validador nacional.`,
  },
  {
    id: 2,
    label: `Experiencia rechazada por el Validador regional o el Validador nacional, al no cumplir con los requisitos. `,
  },
  {
    id: 6,
    label: `Experiencia Aprobada, sin embargo, el Validador nacional la desactiva temporalmente para no estar visible al turista en casos de fuera mayor como desastres naturales en el destino, o debido a incumplimiento de los requisitos.`,
  },
  {
    id: 10,
    label: `Experiencia en proceso de una primera revisión por parte del Validador regional (por la Dirección Regional de SERNATUR). `,
  },
  {
    id: 9,
    label: `Experiencia que ha sido mejorada por el Proveedor y ha sido nuevamente rechazada por el Validador regional o validador nacional de SERNATUR.  `,
  },
]

export default function Status() {
  const columns = [
    {
      dataIndex: `id`,
      label: `ESTADO`,
      align: `center`,
      component: props => <ExperienceStatusBadge status={props} />,
    },
    {
      dataIndex: `label`,
      label: `Definición`,
      align: `center`,
    },
  ]

  return (
    <Grid item container justify="center" alignContent="center" style={{ marginTop: 40 }}>
      <ExperienceTableWrapper loading={false} tableCells={columns} tableBody={data} />
    </Grid>
  )
}
